import React from "react";
import { Card, Result } from "antd";
import { ToolOutlined } from "@ant-design/icons";

/**
 * Página padrão para funcionalidades em desenvolvimento.
 */
const UnderDevelopment: React.FC = () => {
  return (
    <Card>
        <Result
          icon={<ToolOutlined style={{ color: "#faad14" }} />}
          title="Em Desenvolvimento"
          subTitle="Esta funcionalidade está sendo desenvolvida e estará disponível em breve."
        />
      </Card>
  );
};

export default UnderDevelopment;
